export default __webpack_public_path__ + "static/media/clients.8747967b.svg";